type ExtendedWindow = Window &
  typeof global & {
    setTtsPlaying?: (playing: boolean) => void;
    invokeCSharpAction?: (data: string) => unknown;
  };

export const extendedWindow: ExtendedWindow = window as ExtendedWindow;
